<div class="px-3">

  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-bell font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Notification Settings</div>
        <div class="text-right mt-2">Manage notification settings</div>
      </div>
      
    </div>
  </div>

  <div>

    <creditor-autocomplete
      [styleClass]="'w-5'"
      (onSelect)="onSelectCreditor($event)"
    ></creditor-autocomplete>

   <div class="w-5 mt-6">
    <p-floatLabel>
      <p-autoComplete 
         styleClass="w-full"
         [(ngModel)]="sms" 
         [suggestions]="filteredSmsPlatformTypeList"  
         (completeMethod)="filterSmsPlatformType($event)" 
         [dropdown]="true" 
         optionLabel="name"
         placeholder="Select SMS Platform"
         id="sms"
         >
          <ng-template let-row pTemplate="item">
              <div class="flex align-items-center justify-content-between flex-1">
                <div>{{row.name}}</div>    
                <div>{{row.value}}</div>
              </div>
          </ng-template>
      </p-autoComplete>
      <label for="sms">SMS</label>
    </p-floatLabel>
  </div>


  <div class="w-5 mt-6">
    <p-floatLabel>
      <p-autoComplete 
         styleClass="w-full"
         [(ngModel)]="email" 
         [suggestions]="filteredEmailPlatformTypeList"  
         (completeMethod)="filterEmailPlatformType($event)" 
         [dropdown]="true" 
         optionLabel="name"
         placeholder="Select Email Platform"
         id="email"
      >
        <ng-template let-row pTemplate="item">
            <div class="flex align-items-center justify-content-between flex-1">
              <div>{{row.name}}</div>    
              <div>{{row.value}}</div>
            </div>
        </ng-template>
      </p-autoComplete>
      <label for="email">Email</label>
    </p-floatLabel>
  </div>

  <div class="flex justify-content-end w-5 mt-6">
    <remitter-button
      (click)="onClickSubmit()" 
      label='Submit'
      icon='send'
    /> 
  </div>
 
  </div>
</div>